import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import Navbar from "../../components/navbar";
import { useGetCartItemsQuery } from "../../redux/services/cart";
import { useSelector } from "react-redux";
import Footer from "../../components/footer";
import Switcher from "../../components/switcher";
import ScrollToTop from "../../components/scroll-to-top";
import { GoCheckCircle } from "react-icons/go";
import { useGetOrderDetailQuery } from "../../redux/services/orders";
import Loader from "../../components/Loader";

const OrderConfirmation = () => {
  const user = useSelector((state) => state.auth.user);

  const [shopOrder , setShopOrder] = useState(null);

  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');

  const { data } = useGetCartItemsQuery({
    filter: { user_id: user.id },
  });

  const { data: orderDetails, isLoading } = useGetOrderDetailQuery({
    filter: { id: id },
  });
  
  useEffect(() => {

    if(orderDetails){
      setShopOrder(orderDetails[0]);
    }
  }, [orderDetails]);

  return (
    <>
      <Navbar navClass="defaultscroll is-sticky" />
      <section className="relative table w-full py-20 lg:py-24 md:pt-28 bg-gray-50 dark:bg-slate-800">
        <div className="container relative">
          <div className="grid grid-cols-1 mt-14">
            <h3 className="text-3xl leading-normal font-semibold">Fashion</h3>
          </div>

          <div className="relative mt-3">
            <ul className="tracking-[0.5px] mb-0 inline-block">
              <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500">
                <Link to="/">TAS e store</Link>
              </li>
              <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180">
                <i className="mdi mdi-chevron-right"></i>
              </li>
              <li
                className="inline-block uppercase text-[13px] font-bold text-orange-500"
                aria-current="page"
              >
                Confirmation
              </li>
            </ul>
          </div>
        </div>
      </section>

      {isLoading ? 
        <Loader />      
      :
      <section className="relative md:py-24 py-16">
        <div className="container relative">
          <div className="grid lg:grid-cols-12 md:grid-cols-2 grid-cols-1 gap-6">
            <div className="lg:col-span-8">
              <div className="p-6 rounded-md shadow dark:shadow-gray-800 flex flex-row items-center gap-2 ">
                <GoCheckCircle style={{ color: "#00bfa6", fontSize: "48px" }} />
                <h3 className="text-xl leading-normal font-semibold">
                  Order Confirmed
                </h3>
              </div>
              <div className="p-6 rounded-md shadow dark:shadow-gray-800 mt-6">
                <h3 className="text-xl leading-normal font-semibold">
                  Order Details
                </h3>

                <form
                // onSubmit={handleSubmit(onSubmit)}
                >
                  <div className="grid lg:grid-cols-12 grid-cols-1 mt-6 gap-5">
                    <div className="lg:col-span-6">
                      <h2 className="form-label font-semibold">
                        Contact information
                      </h2>
                      <p>{shopOrder?.email && shopOrder?.email}</p>
                    </div>

                    <div className="lg:col-span-6">
                      <h2 className="form-label font-semibold">
                        Payment method
                      </h2>
                      <div className="flex flex-row items-center">
                        <p>
                          {shopOrder?.payment_type === "COD" &&
                            "Cash on Delivery (COD) - "}
                        </p>
                        {/* <p className="font-semibold"> $ {totalPrice + 150}</p> */}
                      </div>
                    </div>

                    <div className="lg:col-span-6">
                      <h2 className="form-label font-semibold">
                        Shipping address
                      </h2>
                      <p>{shopOrder?.name && shopOrder?.name}</p>
                      <p>{shopOrder?.billing_address && shopOrder?.billing_address}</p>
                      <p>{shopOrder?.state && shopOrder?.state} , 
                      {shopOrder?.country && shopOrder?.country} 
                      {shopOrder?.zip_code && shopOrder?.zip_code}</p>

                    </div>
                    <div className="lg:col-span-6">
                      <h2 className="form-label font-semibold">
                        Phone Number
                      </h2>
                      <p>{shopOrder?.phone && shopOrder?.phone}</p>

                    </div>
                  </div>
                  <div className="mt-4">
                    <Link
                    to="/"
                    className="py-2 px-5 inline-block tracking-wide align-middle duration-500 text-base text-center bg-orange-500 text-white rounded-md w-full"
                  >
                    Continue to shop
                  </Link>
                  </div>
                </form>
              </div>
            </div>

            <div className="lg:col-span-4">
              <div className="p-6 rounded-md shadow dark:shadow-gray-800">
                <div className="flex justify-between items-center">
                  <h5 className="text-lg font-semibold">Your Order</h5>

                  <Link
                    to="#"
                    className="bg-orange-500 flex justify-center items-center text-white text-[10px] font-bold px-2.5 py-0.5 rounded-full h-5"
                  >
                    {orderDetails[0]?.product_details?.length}
                  </Link>
                </div>

                <div className="mt-4 rounded-md shadow dark:shadow-gray-800">
                  {orderDetails[0]?.product_details?.map((item, index) => {
                    return (
                      <div
                        className="p-3 flex justify-between items-center"
                        key={index}
                      >
                        <div>
                          <h5 className="font-semibold">
                            {item.product_name}
                          </h5>
                         
                        </div>

                        <p className="text-slate-400 font-semibold">
                          {" "}
                          $ {item.product_price}{" "}
                        </p>
                      </div>
                 
                    );
                  })}
                  <div className="p-3 flex justify-between items-center border border-gray-100 dark:border-gray-800">
                    <div>
                      <h5 className="font-semibold">Total (USD)</h5>
                    </div>

                    <p className="font-semibold">$ {orderDetails[0]?.total_amount}</p>
                  </div>
                </div>

              
              </div>
            </div>
          </div>
        </div>

   
      </section>
      }

      <Footer />
      {/* <Switcher /> */}
      <ScrollToTop />
    </>
  );
};

export default OrderConfirmation;
